<div
    class="string-group-or-custom-value"
    provideParentForm
>
    <div
        *ngFor="let config of stringGroupRefOrCustomValuesConfigs; trackBy: trackByIndex; let index = index"
        class="string-group-or-custom-value__container"
    >
        <div class="string-group-or-custom-value__header">
            <label
                aviLabelWithTooltip
                [required]="areStringGroupOrCustomFieldsRequired"
            >
                {{ headerLabel }}
            </label>
            <button
                *ngIf="stringGroupRefOrCustomValuesConfigs.length > 1"
                class="string-group-or-custom-value__remove-button"
                (click)="removeItem(index)"
                [disabled]="disabled"
            >
                <cds-icon
                    shape="trash"
                    size="18"
                    status="info"
                ></cds-icon>
            </button>
        </div>
        <avi-radio-container
            [noMarginTop]="noMarginTop"
            *ngIf="!disallowStringGroups"
        >
            <avi-radio
                name="{{ 'string-group-or-custom-value_string-type_' + id + '_' + index}}"
                value="{{ StringType.STRING_GROUP }}"
                [(ngModel)]="config.stringType"
                (ngModelChange)="handleStringTypeChange(index)"
                [disabled]="disabled"
            >
                {{ l10nKeys.selectFromAvailableLabel | vtranslate }}
            </avi-radio>
            <avi-radio
                name="{{ 'string-group-or-custom-value_string-type_' + id + '_' + index }}"
                value="{{ StringType.CUSTOM_VALUE }}"
                [(ngModel)]="config.stringType"
                (ngModelChange)="handleStringTypeChange(index)"
                [disabled]="disabled"
            >
                {{ l10nKeys.enterCustomValueLabel | vtranslate }}
            </avi-radio>
        </avi-radio-container>
        <div *ngIf="config.stringType === StringType.STRING_GROUP">
            <avi-collection-dropdown
                [collection]="stringGroupCollection"
                [(ngModel)]="config.stringGroupRef"
                (ngModelChange)="handleStringGroupRefsChange()"
                placeholder="{{ globalL10nKeys.selectStringGroupPlaceholder | vtranslate }}"
                name="{{ 'string-group-or-custom-value_string-group-uuid_' + id + '_' + index }}"
                [disabled]="disabled"
                [required]="areStringGroupOrCustomFieldsRequired"
            ></avi-collection-dropdown>
        </div>
        <div *ngIf="config.stringType === StringType.CUSTOM_VALUE">
            <avi-input-container noMarginTop>
                <avi-repeated-strings
                    placeholder="{{ l10nKeys.enterCustomValueLabel | vtranslate }}"
                    name="{{ 'string-group-or-custom-value_custom-value_' + id + '_' + index }}"
                    [(ngModel)]="config.matchStrings"
                    (ngModelChange)="handleCustomValuesChange()"
                    [disabled]="disabled"
                    [required]="areStringGroupOrCustomFieldsRequired"
                    [allowDuplicates]="areDuplicateCustomValuesAllowed"
                ></avi-repeated-strings>
            </avi-input-container>
        </div>
    </div>
    <cds-button
        *ngIf="!disallowStringGroups && showAddItemButton"
        class="string-group-or-custom-value__add-button"
        action="flat"
        size="sm"
        (click)="addItem()"
        [disabled]="disabled"
    >
        <cds-icon shape="plus-circle"></cds-icon>
        {{ l10nKeys.addItemLabel | vtranslate }}
    </cds-button>
</div>
